import React, { ReactElement } from 'react'
import { alpha, Toolbar, Typography } from '@mui/material'

export function TableToolbar({
  title,
  numSelected,
  toolBarItems,
}: {
  title: React.ReactNode
  numSelected: number
  toolBarItems?: ReactElement[]
}) {
  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity,
            ),
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography
          sx={{ flex: '1 1 100%' }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          sx={{ flex: '1 1 100%' }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {title}
        </Typography>
      )}
      {toolBarItems}
    </Toolbar>
  )
}
